import React, { PropsWithChildren } from 'react';

import { AppBarRenderError } from './AppBarRenderError';

interface AppBarErrorBoundaryState {
    hasError: boolean;
    error?: Error;
    errorInfo?: React.ErrorInfo;
    boundarySource: string;
}

interface AppBarErrorBoundaryProps {
    /** Indicates the source or location the error boundary is used */
    boundarySource: string;
}

export class AppBarErrorBoundary extends React.Component<
    PropsWithChildren<AppBarErrorBoundaryProps>,
    AppBarErrorBoundaryState
> {
    constructor(props: PropsWithChildren<AppBarErrorBoundaryProps>) {
        super(props);
        this.state = { hasError: false, boundarySource: props.boundarySource };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        this.setState({
            hasError: true,
            error: error,
            errorInfo: errorInfo,
        });
    }

    render() {
        return this.state.hasError ? (
            <AppBarRenderError
                error={this.state.error}
                errorInfo={this.state.errorInfo}
                boundarySource={this.state.boundarySource}
            />
        ) : (
            this.props.children
        );
    }
}
